'use client';

const PopoverToggle: React.FC<{
  tag: 'li' | 'div' | 'span';
  show?: boolean;
  children: React.ReactNode;
}> = ({
  tag: Tag,
  show,
  children,
}) => (
    <Tag onClick={(e) => {
      const element = e.currentTarget.closest('[popover]');
      if (element && 'togglePopover' in element) {
        (element.togglePopover as (force?: boolean) => void)(show);
      }
    }}>
      {children}
    </Tag>
  );

export default PopoverToggle;
